import React, { useContext, useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { Check } from 'react-feather';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { blankAddUserInfo, fetchUserInfo, updateUserInfo } from '../../redux/slices/VerifyInfoSlice';
import Loader from '../../components/Loader';
import NotyfContext from '../../contexts/NotyfContext';
import { handleScriptLoad } from '../../constants';
import OnboardingSteps from '../../components/new/OnboardingSteps';
import $ from 'jquery';
import { callUserActvity } from '../../redux/slices/CommonSlice';

import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask';
const VerifyInfo = () => {
  const navigate = useNavigate();
  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const verifyInfoStatus = useSelector(state => state.verifyInfo.status);
  const userInfo = useSelector(state => state.verifyInfo.userInfo);
  const updateUserInfoState = useSelector(state => state.verifyInfo.updateUserInfoState);
  const error = useSelector(state => state.verifyInfo.error);

  const [info, setInfo] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    address: '',
    country: '',
    state: '',
    zip: '',
    dob: '',
    address2: '',
    id: null,
    terms: true,
  });

  useEffect(() => {
    dispatch(fetchUserInfo());
  }, []);

  useEffect(() => {
    if (userInfo && Object.keys(userInfo).length > 0) {
      if (userInfo.error === 0) {
        let data = userInfo.data;
        let obj = {
          firstname: data.first_name,
          lastname: data.last_name,
          email: data.email,
          phone: data.phone,
          dob: data.dob,
          address: data.address,
          address2: data.address2,
          country: data.country,
          state: data.state,
          zip: data.zip,
          terms: eval(data.is_confirmed),
          id: data.id,
        };
        setInfo(obj);

        handleScriptLoad(data.address2 ? `${data.address} ${data.address2}` : data.address, place => {
          if (place) {
            const newInfo = {
              address: '',
              address2: '',
              country: '',
              state: '',
              zip: '',
            };
            place.address_components.forEach(component => {
              const componentType = component.types[0];
              switch (componentType) {
                case 'street_number': {
                  newInfo.address = `${component.long_name} ${newInfo.address}`;
                  break;
                }
                case 'subpremise':
                  newInfo.address2 = component.long_name;
                  break;

                case 'route': {
                  newInfo.address += component.short_name;
                  break;
                }

                case 'postal_code': {
                  newInfo.zip = `${component.long_name}`;
                  break;
                }

                case 'locality':
                  newInfo.country = component.long_name;
                  break;

                case 'administrative_area_level_1': {
                  newInfo.state = component.short_name;
                  break;
                }
              }

              setInfo({ ...obj, ...newInfo });
            });
          }
        });
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (updateUserInfoState && Object.keys(updateUserInfoState).length > 0) {
      if (updateUserInfoState.error == 0) {
        dispatch(callUserActvity('Click on verify personal info'));
        notyf.open({
          type: 'success',
          message: 'Update info successfully',
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });

        dispatch(blankAddUserInfo());
        navigate('/upload-document');
      } else {
        notyf.open({
          type: 'danger',
          message: updateUserInfoState.msg || updateUserInfoState.data,
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
        dispatch(blankAddUserInfo());
      }
    }
  }, [updateUserInfoState]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstname: info.firstname,
      lastname: info.lastname,
      email: info.email,
      phone: info.phone,
      address: info.address,
      address2: info.address2,
      country: info.country,
      state: info.state,
      zip: info.zip,
      dob: info.dob,
      terms: info.terms,
      id: info.id,
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
      firstname: Yup.string().max(255).required('First Name is required'),
      lastname: Yup.string().max(255).required('Last Name is required'),
      phone: Yup.string().max(255).required('Phone is required'),
      address: Yup.string().max(255).required('Address is required'),
      country: Yup.string().max(255).required('City is required'),
      state: Yup.string().max(255).required('State is required'),
      zip: Yup.string().max(255).required('Zip is required'),
      dob: Yup.string().max(12).required('Date of Birth is required'),
      terms: Yup.boolean().oneOf([true], 'Please Select terms and condition'),
    }),
    onSubmit: async values => {
      let obj = {
        id: values.id,
        first_name: values.firstname,
        last_name: values.lastname,
        email: values.email,
        phone: values.phone,
        address: values.address,
        address2: values.address2,
        country: values.country,
        state: values.state,
        terms: values.terms && 1,
        zip: values.zip,
        dob: values.dob,
      };

      const changed = Object.keys(info)
        .filter(key => key != 'terms')
        .map(key => values[key] == info[key])
        .includes(false);

      if (changed) {
        $.confirm({
          title: `Confirm Information Changes`,
          content: `<p>You've made changes to your information that differs from your report.</p> <p> This is NOT a bad thing because having the most accurate info increases your ability to get deletions! We just want to make sure that you meant to make that change.</p><p> Do you wish to continue?</p>`,
          type: 'blue',
          buttons: {
            yes: {
              text: 'Yes',
              btnClass: 'btn btn-outline-primary',
              keys: ['enter'],
              action: function () {
                dispatch(updateUserInfo(obj));
              },
            },
            no: {
              text: 'No',
              btnClass: 'btn btn-outline-danger',
              action: () => {},
            },
          },
        });
      } else {
        dispatch(updateUserInfo(obj));
      }
    },
  });
  if (verifyInfoStatus === 'loading') {
    return <Loader />;
  } else if (verifyInfoStatus === 'failed') {
    notyf.open({
      type: 'danger',
      message: error,
      duration: '3000',
      ripple: false,
      dismissible: false,
      position: {
        x: 'right',
        y: 'top',
      },
    });
  }

  const phoneMask = createDefaultMaskGenerator('(999) 999 9999');
  return (
    <React.Fragment>
      <Helmet title='Verify Information' />
      <style>
        {`
            .form-check-input {
              width: 15px;
              height: 15px;
              border: 1.2px solid var(--bs-dark-blue);
            }
             @media (max-width: 1284px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 410px !important;
                }
              }

              @media (max-width: 992px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 410px !important;
                }
              }

              @media (max-width: 768px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 400px !important;
                }
              }
          `}
      </style>
      <Container className='p-0'>
        <OnboardingSteps activeStepButtonLeft='-2px' progressComplete='470px' activeStep={3} />
        <Row>
          <Col xs='10' md='6' className='mx-auto mb-4 mt-5'>
            <h3 className='audit-heading'>Verify Your Information!</h3>
            <p className='text-dark-blue'>Your Negative Items have been confirmed and are prepped for disputing!</p>
            <p className='text-dark-blue'>The information populated below has been extracted directly from your credit reports. Our Enhanced plan offers the chance to challenge inaccuracies in your personal information. Please make sure that your information is correct, as this can bring about positive changes in your credit scores.</p>
          </Col>
        </Row>
        <Row>
          <Col xs='10' md='6' className='mx-auto'>
            <h3>Confirm your personal information</h3>
            {/* <p>The information below was pulled directly from your credit information. Correcting incorrect information could end up being the single most important action you take upon starting this process; please carefully verify that all the information is acurate..</p> */}
            <Form onSubmit={formik.handleSubmit}>
              <Row>
                <Form.Group className='col-lg-4 mb-3'>
                  <Form.Label className='text-light-gray form-label'>First name</Form.Label>
                  <Form.Control type='text' name='firstname' id='firstname' placeholder='First Name' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.firstname} isInvalid={Boolean(formik.touched.firstname && formik.errors.firstname)} />
                  {!!formik.touched.firstname && <Form.Control.Feedback type='invalid'>{formik.errors.firstname}</Form.Control.Feedback>}
                </Form.Group>
                <Form.Group className='col-lg-4 mb-3'>
                  <Form.Label className='text-light-gray form-label'>Last name</Form.Label>
                  <Form.Control type='text' name='lastname' id='lastname' placeholder='Last Name' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.lastname} isInvalid={Boolean(formik.touched.lastname && formik.errors.lastname)} />
                  {!!formik.touched.lastname && <Form.Control.Feedback type='invalid'>{formik.errors.lastname}</Form.Control.Feedback>}
                </Form.Group>
                <Form.Group className='col-lg-4 mb-3'>
                  <Form.Label className='text-light-gray form-label'>Date of Birth</Form.Label>
                  <Form.Control type='date' name='dob' id='dob' placeholder='Last Name' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.dob} isInvalid={Boolean(formik.touched.dob && formik.errors.dob)} />
                  {!!formik.touched.dob && <Form.Control.Feedback type='invalid'>{formik.errors.dob}</Form.Control.Feedback>}
                </Form.Group>
              </Row>
              <Row className='mb-4'>
                <Form.Group className='col-lg-6 mb-3'>
                  <Form.Label className='text-light-gray form-label'>Email</Form.Label>
                  <Form.Control type='text' readOnly name='email' id='email' placeholder='Email' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.email} isInvalid={Boolean(formik.touched.email && formik.errors.email)} />
                  {!!formik.touched.email && <Form.Control.Feedback type='invalid'>{formik.errors.email}</Form.Control.Feedback>}
                </Form.Group>
                <Form.Group className='col-lg-6 mb-3'>
                  <Form.Label className='text-light-gray form-label'>Phone</Form.Label>
                  <MaskedInput
                    maskGenerator={phoneMask}
                    type='text'
                    id='phone'
                    name='phone'
                    className={`form-control form-control-lg ${Boolean(formik.touched.phone && formik.errors.phone) ? 'is-invalid' : ''}`}
                    placeholder='(123) 456 7890'
                    size='lg'
                    onChange={e => {
                      formik.setFieldValue('phone', e);
                    }}
                    value={formik.values.phone}
                    isInvalid={Boolean(formik.touched.phone && formik.errors.phone)}
                    onBlur={formik.handleBlur}
                  />
                  {!!formik.touched.phone && <Form.Control.Feedback type='invalid'>{formik.errors.phone}</Form.Control.Feedback>}
                </Form.Group>
              </Row>
              <Row>
                <Form.Group className='col-lg-8 mb-3'>
                  <Form.Label className='text-light-gray form-label'>Address Line 1</Form.Label>
                  <Form.Control type='text' name='address' id='address' placeholder='Address' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.address} isInvalid={Boolean(formik.touched.address && formik.errors.address)} />
                  {!!formik.touched.address && <Form.Control.Feedback type='invalid'>{formik.errors.address}</Form.Control.Feedback>}
                </Form.Group>
                <Form.Group className='col-lg-4 mb-3'>
                  <Form.Label className='text-light-gray form-label'>Address Line 2</Form.Label>
                  <Form.Control type='text' name='address2' id='address2' placeholder='Address 2 (Optional)' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.address2} />
                </Form.Group>
              </Row>
              <Row>
                <Form.Group className='col-lg-6 mb-3'>
                  <Form.Label className='text-light-gray form-label'>City</Form.Label>
                  <Form.Control type='text' name='country' id='country' placeholder='City' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.country} isInvalid={Boolean(formik.touched.country && formik.errors.country)} />
                  {!!formik.touched.country && <Form.Control.Feedback type='invalid'>{formik.errors.country}</Form.Control.Feedback>}
                </Form.Group>
                <Form.Group className='col-lg-2 mb-3'>
                  <Form.Label className='text-light-gray form-label'>State</Form.Label>
                  <Form.Control type='text' name='state' id='state' placeholder='State' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.state} isInvalid={Boolean(formik.touched.state && formik.errors.state)} />
                  {!!formik.touched.state && <Form.Control.Feedback type='invalid'>{formik.errors.state}</Form.Control.Feedback>}
                </Form.Group>
                <Form.Group className='col-lg-4 mb-3'>
                  <Form.Label className='text-light-gray form-label'>Zip Code</Form.Label>
                  <Form.Control type='text' name='zip' id='zip' placeholder='Zip' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.zip} isInvalid={Boolean(formik.touched.zip && formik.errors.zip)} />
                  {!!formik.touched.zip && <Form.Control.Feedback type='invalid'>{formik.errors.zip}</Form.Control.Feedback>}
                </Form.Group>
              </Row>
              <Row className='mb-5 mt-4'>
                <Col>
                  <Form.Check className={Boolean(formik.touched.terms && formik.errors.terms) ? 'text-danger' : 'text-dark-blue border-secondary border-2'} type='checkbox' label='I verify the information above is accurate. I understand that failing to correct inaccruate information could lead to little to no results.' id='terms' name='terms' size={30} onChange={formik.handleChange} onBlur={formik.handleBlur} checked={formik.values.terms == 1} value={1} isInvalid={Boolean(formik.touched.terms && formik.errors.terms)} />
                  {!!formik.touched.terms && <Form.Control.Feedback type='invalid'>{formik.errors.terms}</Form.Control.Feedback>}
                </Col>
              </Row>
              <Row className='my-5'>
                <Col className='d-flex justify-content-between'>
                  <Button variant='outline-primary' onClick={() => navigate('/report-audit')} className='fs-16 w-25' style={{ zIndex: '9999999999' }}>
                    Back
                  </Button>
                  <Button variant='primary' size='lg' className='fs-16 w-md-25 w-50' type='submit' disabled={formik.isSubmitting} style={{ zIndex: '9999999999' }}>
                    Continue
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default VerifyInfo;
